// ==================== IMPORTS ====================

import React from 'react';
import * as Yup from 'yup';
import { Modal } from 'react-bootstrap';
import "./InviteExternalInfluencer.scss";
import { toast } from 'react-toastify';
import { CrossIcon } from '../../../../Assets/svgIcons';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { shareExternalInvitation } from '../../../../Services/prod/auth.service';

const InviteExternalInfluencer = ({ show, auctionId, auctionName, handleClose, screenShot }) => {

    // ==================== VALIDATION SCHEMA ====================
    const validationSchema = Yup.object().shape({
        influencerName: Yup.string()
            .min(3, 'Name must be at least 3 characters')
            .max(20, 'Name can be at most 20 characters')
            .required('Name is required'),
        issuerName: Yup.string()
            .min(3, 'Name must be at least 3 characters')
            .max(20, 'Name can be at most 20 characters')
            .required('Name is required'),
        email: Yup.string().email('Invalid email address').required('Email is required'),
        phone: Yup.string()
            .matches(/^\d+$/, 'Contact number must be numeric')
            .min(10, 'Contact number must be at least 10 digits')
            .max(15, 'Contact number can be at most 15 digits')
            .required('Contact number is required'),
        description: Yup.string()
            .min(10, 'Description must be at least 10 characters')
            .max(500, 'Description can be at most 500 characters')
            .required('Description is required'),
    });

    // ==================== INITIAL VALUES ====================
    const initialValues = {
        email: '',
        phone: '',
        issuerName: '',
        description: '',
        influencerName: '',
    };

    // ==================== SUBMIT HANDLER ====================
    const onSubmit = async (values, { resetForm }) => {
        try {
            if (values) {
                const externalInvitationPayload = {
                    email: values?.email,
                    mobile: values?.phone,
                    issuer_name: values?.issuerName,
                    description: values?.description,
                    auction_id: auctionId || null,
                    auction_name: auctionName || null,
                    auction_image: screenShot || null,
                    influencer_name: values?.influencerName,
                };
                const externalInvitationRes = await shareExternalInvitation(externalInvitationPayload);
                if (externalInvitationRes?.status === 200 || externalInvitationRes?.status === 201) {
                    toast?.success(externalInvitationRes?.message);
                    resetForm();
                    handleClose();
                } else {
                    console.log('***** API ERROR *****');
                }
            }
            else {
                console.log('***** MISSING VALUES *****');
            }
        } catch (error) {
            console.log(error, "error");

        }
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            backdropClassName="invite_external_influencer_modal_bg"
            className="invite_external_influencer_modal"
        >
            <button onClick={handleClose} className="cross_btn" type="button">
                <CrossIcon />
            </button>
            <h3>Invite External Influencer</h3>
            <p className="desc_txt">
                {/* Invite external influencers to your auction, just enter the influencer e-mail address and we will do the rest */}
                <span style={{ color: "red" }}>Note</span>: Your contact details (email and phone number) and your personal note will be shared with the Invited Influencer.
            </p>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ isSubmitting }) => (
                    <Form>
                        <div className="custom_input">
                            <label htmlFor="email">
                                Your Name <span>*</span>
                            </label>
                            <Field type="text" name="issuerName" placeholder="Enter Your Name" />
                            <ErrorMessage name="issuerName" component="div" className="error" />
                        </div>
                        <div className="custom_input">
                            <label htmlFor="phone">Your Phone number <span>*</span> </label>
                            <Field type="text" name="phone" placeholder="Enter Your Number" />
                            <ErrorMessage name="phone" component="div" className="error" />
                        </div>
                        <div className="custom_input">
                            <label htmlFor="email">
                                Influencer Name <span>*</span>
                            </label>
                            <Field type="text" name="influencerName" placeholder="Enter Influencer Name" />
                            <ErrorMessage name="influencerName" component="div" className="error" />
                        </div>
                        <div className="custom_input">
                            <label htmlFor="email">
                                Influencer Email <span>*</span>
                            </label>
                            <Field type="email" name="email" placeholder="Enter Influencer Email" />
                            <ErrorMessage name="email" component="div" className="error" />
                        </div>
                        <div className="custom_input">
                            <label htmlFor="description">Personal Note to the Invited Influencer <span>*</span> </label>
                            <Field
                                as="textarea"
                                name="description"
                                id="description"
                                placeholder="Enter a note"
                            />
                            <ErrorMessage name="description" component="div" className="error" />
                        </div>
                        <button type="submit" disabled={isSubmitting}>
                            Invite
                        </button>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default InviteExternalInfluencer;
